import React from 'react';
// Constants
import { CompanyName } from '../../utils/constants/Constants';
// Components
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';
import CallToActionOne from '../cta/CallToActionOne';
import FavouriteServices from '../services/FavouriteServices';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
import CustomContent from './CustomContent';

function HomePageMainContainer() {
  return (
    <main role='main' className='grid w-full overflow-hidden h-full mb-4 mt-8'>
      {/* Main */}
      <section className='grid w-full pb-12'>
        <div className='grid px-8 sm:px-10 lg:container lg:mx-auto lg:max-w-2xl'>
          <article className='grid h-fit gap-6 text-center'>
            <p className='text-xl lg:text-3xl text-center text-colour7 font-titleFont pt-2 font-semibold'>
              Meet your ultimate obsession - {CompanyName}
            </p>
            <p className=''>
              I am the muscle Goddess you’ve been craving, the embodiment of
              power and dominance. Call Me <strong>“Queen”</strong> because
              you’re about to bow to My every command. Every moment spent with
              Me will remind you of your place.
              <strong>
                {' '}
                I’ll own your thoughts and actions as you become more and more
                desperate to please Me.
              </strong>
            </p>
            <p className=''>
              I’ve built My strength and confidence through years of discipline
              and passion. With a body that commands respect and a mind that
              thrives on control,
              <strong>
                {' '}
                I take pleasure in making you yearn for My approval.
              </strong>
            </p>
            <p className=''>
              <strong>Now that I’ve caught your attention,</strong> show Me your
              devotion. The purpose of your presence is clear — serve, obey, and
              worship.
              <strong>
                {' '}
                Prove that you understand your place and submit to My reign.
              </strong>
            </p>
          </article>
        </div>
      </section>

      {/* Fav services */}
      <FavouriteServices />

      {/* Custom clips cta */}
      {/* <CustomContent /> */}

      {/* Images */}
      <div className='pt-8 bg-colour8'>
        <SmallGalleryComponent />
      </div>

      {/* CTA */}
      <div className='md:mb-4 pt-8 lg:mb-12'>
        <CallToActionOne />
      </div>

      {/* Article */}
      {/* <div className='md:mb-4 pt-12 lg:mb-12'>
        <LatestArticlesComponent />
      </div> */}

      {/* Social cta */}
      <SocialMediaCtaComponent />
    </main>
  );
}

export default HomePageMainContainer;
